import { useMutation } from "@apollo/react-hooks";
import { Labelled, Modal } from "@shopify/polaris";
import React, { useCallback, useRef } from "react";
import { useToastContext } from "../../shared/ToastContext";
import { MediaSelectorButtonPolaris } from "../../file/MediaSelectorButtonPolaris";
import { SEND_INVOICE_ATTACHMENT } from "../../../graphql/mutations";
import { arrInvalid, handleError } from "../../../helper";
import useTimeout from "../../../hooks/useTimeout";
import history from "../../../history";

export default function SendWithAttachment({
    open,
    onClose,
    invoiceId,
    pathnameGoBack,
}) {
    const { toggleToast, setNotify } = useToastContext();

    const [setDelay] = useTimeout();
    const [sendAttachment, { loading }] = useMutation(SEND_INVOICE_ATTACHMENT, {
        onCompleted: () => {
            setNotify({
                msg: "Send invoice with attachments success",
                err: false,
            });

            setDelay(() => {
                onClose();
                if (pathnameGoBack) {
                    history.push(pathnameGoBack);
                }
            }, 1500);
        },
        onError: (err) => {
            setNotify({ msg: handleError(err?.toString()), err: true });
        },
    });

    const fileRef = useRef(null);
    const handleSubmit = useCallback(() => {
        const files = fileRef.current && fileRef.current.getFileList();
        if (arrInvalid(files)) return;
        const ids = files.map((item) => item?.id).filter(Boolean);

        toggleToast && toggleToast(true);
        setNotify && setNotify({ msg: null, err: false });
        sendAttachment({
            variables: {
                id: invoiceId,
                fileIDs: ids,
            },
        });
    }, [sendAttachment, invoiceId]);

    return (
        <Modal
            title="Send Invoice Attachments"
            open={open}
            onClose={onClose}
            sectioned
            secondaryAction={[{ content: "Cancel", onAction: onClose }]}
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading: loading,
            }}
        >
            <div>
                <Labelled label="Attachments" />
                <MediaSelectorButtonPolaris
                    accept={"image/*,.pdf"}
                    multiple
                    sizeSmall
                    ref={fileRef}
                />
            </div>
        </Modal>
    );
}
